"use client";
import * as React from "react";
const SvgVisibilityOnSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 .54c-3.636 0-6.742 2.262-8 5.455 1.258 3.192 4.364 5.454 8 5.454s6.742-2.262 8-5.454C14.742 2.802 11.636.54 8 .54Zm0 9.09a3.638 3.638 0 0 1-3.636-3.635A3.638 3.638 0 0 1 8 2.358a3.638 3.638 0 0 1 3.636 3.637A3.638 3.638 0 0 1 8 9.63Zm0-5.817a2.179 2.179 0 0 0-2.182 2.182c0 1.207.975 2.181 2.182 2.181a2.179 2.179 0 0 0 2.182-2.181A2.179 2.179 0 0 0 8 3.813Z" }));
export {
  SvgVisibilityOnSharp as default
};
